import { Marker, Popup } from "react-leaflet";

import { ICameraLayer } from "../models/Layers";
import React from "react";
import camera from "../camera.png";
import { icon } from "leaflet";
import { observer } from "mobx-react-lite";

export interface CameraLayerProps {
  model: ICameraLayer;
}

const CameraLayer = ({ model: { visible, cameras } }: CameraLayerProps) => {
  if (!visible) {
    return <></>;
  }
  const cameraIcon = icon({ iconUrl: camera, iconSize: [30, 30] });
  return (
    <>
      {cameras.map(({ name, url, location }) => (
        <Marker key={name} position={location} icon={cameraIcon}>
          <Popup minWidth={400}>
            <b>{name}</b>
            <br />
            <a href={url} target="_new">
              <img src={url} alt={name} />
            </a>
          </Popup>
        </Marker>
      ))}
    </>
  );
};

export default observer(CameraLayer);
